<template>
  <transition name="fade">
    <section class="verify-wrap no-margin" :class="{ 'hide-screen' : hideScreen}">
    <h2>Verify your age</h2>
    <div class="verify-list">
      <section class="verify-list-item">
        <div class="idin-logo">
          <img src="~static/logo-idin.png" alt="">
        </div>
        <h3 >{{ i18n.t('idin:verify_now_content') }}</h3>
        <div  @click="skipValidation(false)" class="verify-action verify-primary">{{ i18n.t('idin:verify_now') }}</div>
      </section>
      <div class="list-delimiter">
        <span></span>
        <p>{{ i18n.t('idin:OR') }}</p>
        <span></span>
      </div>
      <section class="verify-list-item">
        <div class="idin-age">
           <img src="~static/18_plus.png" alt="">
        </div>
        <h3>{{ i18n.t('idin:verify_later_content') }}</h3>
        <div @click="skipValidation(true)" class="verify-action verify-secondary">{{ i18n.t('idin:verify_later') }}</div>
      </section>
    </div>
  </section>
  </transition>
</template>

<script>
export default {
  props: ['screenParams'],
  data () {
    return {
      isSaving: false,
      hideScreen: false
    }
  },
  mounted () {},
  methods: {
    skipValidation (toSkipIdinCheck) {
      this.$store.dispatch('updateUser', {
        skipIdinValidation: toSkipIdinCheck
      })
      this.hideScreen = true

      if (toSkipIdinCheck) {
        setTimeout(() => {
          this.$store.dispatch('next', { ...this.screenParams.nextScreenRoute, skipDelay: true })
        }, 10)
      } else {
        this.$store.dispatch('idinCheck', {description: this.i18n.t('base:idin_api_description')})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../assets/mixins.scss';
  .hide-screen {
    display: none !important;
  }
  .verify-wrap {
    padding: 0 15px;
    margin: 0 -30px;
    margin-top: 0 !important;
    @include desktop {
      flex-direction: row;
    }
    h2 {
      font-family: $headerFontFamily;
      color: $blackTextColor;
      font-size: 24px;
      font-weight: bold;
      line-height: 33px;
      text-align: center;
      margin-bottom: 22px;
      @include desktop {
        margin-top: 0;
        font-size: 30px;
      }
      @include desktop-big {
        margin-top: 50px;
      }
    }

    .verify-list {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      @include desktop {
        flex-direction: row;
      }
      &-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        @include desktop {
            padding-top: 50px;
        }
        h3 {
          color: #818181;
          font-weight: bold;
          font-size: 15px;
          margin: 20px 0;
          white-space: pre-line;
          line-height: 18px;
          text-align: center;
          @include desktop {
              margin-top: 35px;
              margin-bottom: 80px;
          }
        }
        .verify-action {
          border-radius: 50px;
          color: #FFFFFF;
          font-size: 19px;
          line-height: 22px;
          width: 100%;
          max-width: 315px;
          padding: 10px 0;
          text-align: center;
           @include desktop {
            padding: 15px 0;
          }
          cursor: pointer;
          &.verify-primary {
            background: #00B5CE
          }
          &.verify-secondary {
            background: #65AF84
          }

          @include desktop {
              max-width: 270px;
          }

           @include desktop-big{
              max-width: 315px;
          }
        }
      }
    }

    .idin-age img{
        width: 53px;
        @include desktop {
          width: 105px;
        }
    }
    
    .idin-logo img{
        width: 64px;
        @include desktop {
          width: 140px;
        }
    }

    .list-delimiter {
      margin: 22px 0;
      width: 100%;
      display: flex;
      align-items: center;
      span {
        height: 1px;
        background: #4B4B4B;
        width: 100%;
        display: block;
        opacity: 0.3;
      }
      
      p {
        padding: 0 10px;
        font-size: 15px;
        color: #00262B;
        font-weight: bold;
        line-height: 18px;
      }

      @include desktop {
          max-width: 20px;
          position: relative;
          align-self: stretch;
          justify-content: center;
          max-height: 240px;
          span {
            display: none;
          }
          p{
            padding: 3px;
            background: white;
            position: relative;
            z-index: 1;
          }
          &:after {
            content: "";
            width: 1px;
            background: #4B4B4B;
            opacity: 0.3;
            position: absolute;
            height: 100%;
            left: 0;
            right: 0;
            margin: auto;
          }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/screens/VerifyYourAgeTransition.vue